var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoller({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.662 23.791V21.685H15.543V23.791H13.662ZM13.662 9.364V7.249H15.543V9.364H13.662ZM14.697 22.27C13.797 22.27 12.993 22.108 12.285 21.784C11.577 21.46 10.995 21.001 10.539 20.407C10.089 19.807 9.795 19.099 9.657 18.283L11.52 17.986C11.7 18.754 12.084 19.366 12.672 19.822C13.26 20.272 13.965 20.497 14.787 20.497C15.603 20.497 16.266 20.302 16.776 19.912C17.292 19.522 17.55 19.024 17.55 18.418C17.55 17.986 17.418 17.635 17.154 17.365C16.896 17.095 16.473 16.867 15.885 16.681L12.843 15.745C11.043 15.187 10.143 14.107 10.143 12.505C10.143 11.749 10.323 11.092 10.683 10.534C11.049 9.976 11.562 9.544 12.222 9.238C12.882 8.932 13.653 8.779 14.535 8.779C15.381 8.791 16.131 8.947 16.785 9.247C17.445 9.547 17.991 9.979 18.423 10.543C18.861 11.107 19.164 11.785 19.332 12.577L17.415 12.919C17.331 12.457 17.154 12.049 16.884 11.695C16.62 11.341 16.284 11.065 15.876 10.867C15.474 10.669 15.021 10.567 14.517 10.561C14.043 10.549 13.617 10.624 13.239 10.786C12.867 10.942 12.57 11.164 12.348 11.452C12.132 11.734 12.024 12.055 12.024 12.415C12.024 12.811 12.177 13.147 12.483 13.423C12.789 13.699 13.272 13.936 13.932 14.134L16.317 14.827C17.409 15.151 18.198 15.586 18.684 16.132C19.17 16.678 19.413 17.404 19.413 18.31C19.413 19.102 19.215 19.795 18.819 20.389C18.429 20.977 17.88 21.439 17.172 21.775C16.464 22.105 15.639 22.27 14.697 22.27Z",
    fill: "#6F5E7E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    stroke: "#6F5E7E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoller);
export default __webpack_public_path__ + "static/media/doller.5732f8026e60cbedda1d8284e7af2271.svg";
export { ForwardRef as ReactComponent };